// extracted by mini-css-extract-plugin
export default {"loader":"AppWrapper_loader__gYxYy"};